export default "__VITE_ASSET__BGIYMBCX__"